module.exports = __webpack_public_path__ + "static/media/browse.73cd2fee.jpg";